export const aiApplicationSolutions = {
  'ai-threat-intel': {
    title: 'AI加持威胁情报解决方案',
    background:
      '随着数字化转型深入，网络攻击呈现智能化、隐蔽化、规模化趋势，勒索病毒、APT攻击、零日漏洞利用等新型威胁持续爆发，对企业数据安全、业务连续性造成严重威胁。传统威胁情报依赖人工分析，处理效率低下，难以应对海量威胁数据与快速迭代的攻击手段；而单纯AI防御缺乏威胁上下文支撑，误报、漏报率偏高。在此背景下，将AI技术与威胁情报深度融合，依托AI的自动化分析、精准识别能力，结合威胁情报的上下文信息与溯源能力，构建智能化、主动化的安全防御体系，成为应对新型网络威胁、保障数字资产安全的核心需求。',
    challenges: [
      { title: '（一）威胁情报处理效率低，价值难以发挥', desc: '海量威胁情报（包括IOC、攻击战术、漏洞信息等）实时涌入，传统人工分析模式无法快速筛选、关联、研判有价值情报，导致情报滞后于攻击行为，无法及时转化为防御能力，情报价值大打折扣。' },
      { title: '（二）新型威胁隐蔽性强，传统防御难以识别', desc: 'APT攻击、零日漏洞利用等新型威胁具有隐蔽性强、攻击链条长、变种速度快的特点，传统基于规则的防御手段无法精准识别，易出现漏报，导致攻击突破防线、造成损失。' },
      { title: '（三）AI防御误报率高，缺乏上下文支撑', desc: '单纯AI防御模型多依赖行为特征训练，缺乏威胁情报的上下文（如攻击来源、攻击意图）支撑，易将正常业务行为误判为威胁，可能遗漏真正的隐蔽攻击。' },
      { title: '（四）威胁情报与防御体系脱节，联动性不足', desc: '现有威胁情报与防火墙、入侵检测等防御设备缺乏有效联动，情报无法自动同步至防御体系并转化为防御策略，导致“情报与防御两张皮”，无法形成主动防御闭环。' },
    ],
    scenarios: [
      { title: '（一）威胁情报自动化研判场景', desc: '依托AI算法自动处理海量威胁情报，快速筛选、关联IOC、漏洞、攻击战术等信息，研判威胁等级与攻击意图，替代人工分析，大幅提升情报处理效率，让有价值情报快速落地。' },
      { title: '（二）新型威胁精准检测场景', desc: '结合AI的深度学习能力与威胁情报上下文，精准识别APT攻击、零日漏洞利用等隐蔽性威胁，捕捉攻击链条中的异常行为，降低漏报、误报率，提前阻断攻击渗透。' },
      { title: '（三）威胁溯源与攻击预测场景', desc: '通过AI分析威胁情报的关联关系，追溯攻击来源、攻击路径与攻击团伙，同时基于历史情报与攻击模式，预测潜在威胁趋势，实现主动防御、提前预警。' },
      { title: '（四）安全运维智能化减负场景', desc: 'AI自动化完成情报分析、威胁检测、策略更新等重复性工作，减少安全运维人员的工作量，缓解专业人才短缺压力，提升防御响应的及时性与高效性。' },
    ],
    architectureAsset: 'threat-intel-architecture.png',
    advantages: [
      { title: '（一）情报处理高效化，释放情报核心价值', desc: '依托AI自动化分析能力，快速处理海量威胁情报，实现情报筛选、关联、研判的全流程自动化，解决人工分析效率低的痛点，让有价值情报快速转化为防御能力。' },
      { title: '（二）威胁检测精准化，降低防御风险', desc: '融合AI深度学习与威胁情报上下文，精准识别隐蔽性、变种型新型威胁，大幅降低漏报、误报率，提前阻断攻击渗透，全方位提升防御精准度。' },
      { title: 'AI联动一体化，构建主动防御闭环', desc: '打通威胁情报与防御体系的联动壁垒，通过AI实现情报自动同步、策略自动生成与更新，形成“情报研判-威胁检测-策略落地-持续优化”的主动防御闭环。' },
      { title: '（四）运维管理智能化，缓解人才压力', desc: 'AI替代人工完成重复性运维工作，简化运维流程、减少运维工作量，缓解网络安全专业人才短缺困境，提升防御响应效率与运维管理水平。' },
    ],
    caseBackground:
      '某中型城市商业银行，核心业务涉及个人信贷、线上支付等，存储大量客户敏感数据，面临AI换脸盗刷、APT攻击等新型威胁，每日接收海量威胁情报。原有防御依赖人工分析，误报率高、运维压力大，且情报与防御设备联动不足，曾出现客户信息泄露，亟需AI赋能威胁情报构建智能化防御体系。',
    caseDifficulties: [
      '一、海量威胁情报处理效率低下，人工筛选研判无法跟上攻击迭代速度，有价值情报滞后于攻击行为，难以快速转化为防御能力；',
      '二、新型威胁隐蔽性强，AI换脸、变种勒索病毒等攻击手段难以被传统防御识别，漏报、误报率偏高；',
      '三、威胁情报与现有防御设备脱节，无法自动同步并生成防御策略，形成“情报与防御两张皮”；',
      '四、安全运维专业人才短缺，团队难以应对复杂攻击场景与海量情报分析需求，防御响应效率低下，无法满足金融行业合规要求。',
    ],
    caseSolutions: [
      '1. 部署AI赋能威胁情报平台，通过AI自动化处理海量情报，快速筛选研判、剔除无效信息，提升情报处理效率，推动有价值情报落地；',
      '2. 融合AI深度学习与威胁情报上下文，构建检测模型，精准识别隐蔽性威胁，大幅降低漏报、误报率，提前阻断攻击；',
      '3. 打通平台与各类防御设备联动，通过AI自动同步情报、生成并动态更新防御策略，构建主动防御闭环；',
      '4. 依托AI自动化完成重复性运维工作，实现低危威胁自动处置，缓解人才短缺压力，接入反诈资源，满足金融合规要求，保障客户数据与业务安全。',
    ],
  },
  'cloud-edge-model-collaboration': {
    title: '云边大小模型协同解决方案',
    background:
      '随着数字化转型推进，企业运维场景呈现分布式、异构化特征，边缘设备与终端节点激增，运维数据海量集中在边缘侧，对运维响应的实时性、精准性要求大幅提升。传统人工与固定规则运维模式难以适配，单纯云端大模型存在时延高、隐私风险，边缘小模型则受算力限制，泛化能力不足，因此云边大小模型协同架构应运而生，破解运维痛点、推动运维模式向主动预判转型。',
    challenges: [
      { title: '（一）运维数据处理效率低，实时响应不足', desc: '边缘运维数据海量分散，上传云端时延高、带宽占用大，无法满足故障实时处置需求；边缘算力有限，难以完成复杂数据深度分析与故障溯源。' },
      { title: '（二）大小模型协同不畅，能力无法互补', desc: '云端与边缘模型缺乏有效协同机制，参数更新不同步，云端泛化能力无法下沉至边缘，边缘数据也无法反哺云端优化，难以发挥双方优势。' },
      { title: '（三）边缘算力受限，模型部署适配难度大', desc: '边缘设备算力参差不齐，部分轻量化设备无法承载复杂模型部署，且模型版本混乱、适配标准不统一，部署效率低、运维成本高。' },
      { title: '（四）运维故障复杂多样，泛化与精准度难以兼顾', desc: '运维故障类型复杂，边缘小模型泛化能力不足、云端大模型时延高，难以兼顾故障精准识别与快速响应，无法适配多样运维需求。' },
    ],
    scenarios: [
      { title: '（一）边缘设备实时运维处置场景', desc: '针对边缘设备故障、参数异常等场景，由边缘小模型本地化处理运维数据，实现故障实时识别、快速告警与简易处置，避免带宽占用与时延问题，保障边缘业务正常运行。' },
      { title: '（二）复杂运维故障深度研判场景', desc: '当边缘小模型无法识别长尾故障、复合型故障时，将关键数据精简上传至云端大模型，依托其强泛化能力完成深度分析、故障溯源与解决方案生成，同步下发至边缘侧落地处置。' },
      { title: '（三）模型协同迭代与统一部署场景', desc: '云端大模型整合全量运维数据完成训练优化，将轻量化模型参数下发至各边缘节点，实现边缘小模型统一更新适配；边缘侧将本地化运维数据反馈至云端，反哺大模型持续迭代，提升适配性。' },
      { title: '（四）异构边缘设备集约化运维场景', desc: '针对边缘设备算力差异，云端大模型为不同设备定制轻量化小模型，实现模型按需部署；通过云边协同统一管控所有边缘节点模型，简化运维流程、降低运维成本。' },
    ],
    architectureAsset: 'cloud-edge-model-architecture.png',
    advantages: [
      { title: '（一）运维响应高效化，兼顾实时性与深度', desc: '边缘小模型本地化实时处置故障，降低带宽与时延；云端大模型承接复杂故障深度研判，协同兼顾实时性与分析深度，大幅提升运维效率。' },
      { title: '（二）模型协同互补，充分发挥双方优势', desc: '建立完善云边协同机制，实现云端泛化能力下沉、边缘数据反哺云端，破解协同不畅问题，充分释放大小模型核心价值。' },
      { title: '（三）模型部署灵活，适配异构边缘设备', desc: '为不同算力边缘设备定制轻量化模型，按需部署；统一管控模型版本，降低适配难度，有效节约运维成本。' },
      { title: '（四）故障研判精准，适配复杂运维场景', desc: '融合边缘小模型精准识别与云端大模型强泛化能力，覆盖各类故障场景，降低漏判误判率，适配复杂运维需求。' },
    ],
    caseBackground:
      '某大型工业制造企业，业务覆盖多板块，在全国布局多个生产基地，部署大量边缘设备与终端节点，原有运维模式依赖人工与固定规则，存在算力分配不均、跨基地运维响应慢、敏感数据处理不规范等问题，亟需通过云边大小模型协同架构，优化运维效率、平衡算力资源。',
    caseDifficulties: [
      '各基地边缘设备算力差异大，模型部署适配难度高；',
      '跨基地数据传输时延高，算力调度与协同能力不足；',
      '敏感运维数据需本地化处理，同时需保障数据安全与业务连续性。',
    ],
    caseSolutions: [
      '部署云边大小模型协同架构，云端大模型负责全局算力调度与复杂故障分析，边缘小模型承接本地实时运维任务；打通跨基地算力通道，平衡各区域算力负载；优化边缘网络与数据加密机制，实现敏感数据本地化处理，兼顾运维效率与数据安全，大幅提升整体运维集约化水平。',
    ],
  },
  'edge-cv-security': {
    title: '边缘CV应用解决方案',
    background:
      'CV技术在安防、工业巡检等安全领域广泛应用，边缘场景成为核心落地载体，需满足实时性、精准性与隐私性需求。传统“纯边缘小模型”或“纯云端大模型”部署存在明显短板，无法适配多元化需求。瑞和云图基于云边端大小模型协同方案，云端大模型负责全局决策、模型训练优化，边缘小模型承担本地实时推理响应，终端负责数据采集预处理，三者协同破解传统痛点，契合边缘CV安全应用核心诉求，推动其向主动预警、智能防控升级。',
    challenges: [
      { title: '1. 实时性与识别精度的矛盾难以平衡', desc: '边缘CV安全应用需毫秒级响应，但边缘算力有限，小模型精度不足、误漏报率高；依赖云端大模型则时延超300ms，无法满足实时防控需求，二者难以平衡。' },
      { title: '2. 边缘算力资源受限，模型适配难度大', desc: '边缘终端多为低功耗低成本设备，无法部署复杂CV大模型；且不同设备硬件规格不一，异构算力适配难，导致模型部署兼容差、运维成本高，难以灵活更新优化。' },
      { title: '3. 数据隐私与合规风险突出', desc: '采集的图像、视频多为敏感数据，全量上传云端易泄露；政策要求敏感数据本地化处理，传统云端模式无法满足合规要求，隐私保护与全局优化矛盾突出。' },
      { title: '4. 多场景适配与模型迭代效率低', desc: '应用场景多样，单一模型无法适配；边缘风险模式动态变化，纯边缘模型缺乏数据支撑、纯云端模型迭代无法快速同步至边缘，迭代效率低、适配性差。' },
    ],
    scenarios: [
      { title: '1. 工业安全巡检场景', desc: '适配工厂、矿山等工业场景，聚焦设备缺陷、违规操作等防控需求，边缘小模型实时识别常规隐患（时延≤100ms），云端大模型复核复杂场景（精度≥95%），迭代优化适配多厂区，降低人工成本。' },
      { title: '2. 智慧园区安防场景', desc: '覆盖园区重点部位，防控人员入侵、物品遗留等异常，边缘小模型实时识别预警，云端大模型复核提升精度，敏感数据本地处理，云端全局管控优化模型。' },
      { title: '3. 交通安防管控场景', desc: '适用于各类交通场景，边缘小模型实时识别违章、事故等异常并推送预警，云端大模型复核复杂场景，适配多路段需求，提升管控智能化水平。' },
      { title: '4. 敏感区域安防场景', desc: '针对敏感区域，边缘小模型本地处理数据保障隐私，识别各类异常，云端大模型优化定制模型，三级防护满足合规要求，提升防控精度。' },
    ],
    architectureAsset: 'edge-cv-security-architecture.png',
    advantages: [
      { title: '1. 协同调度、平衡实时性与精度', desc: '大小模型智能分流协同：边缘小模型负责常规场景实时推理，时延≤100ms；复杂场景或低置信度任务，仅上传关键特征至云端大模型复核，识别精度≥95%，兼顾实时性与精准性。' },
      { title: '2. 轻量化优化、适配边缘算力', desc: '边缘小模型经量化、剪枝等优化，压缩至原体积30%以下，适配低功耗设备；依托统一算子底座与转换工具链，兼容云端与各类边缘硬件，降低部署适配难度，提升算力利用率。' },
      { title: '3. 本地处理、保障数据安全', desc: '敏感数据本地处理，仅上传推理结果或关键特征，降低泄露风险；云端基于非敏感数据训练优化，支持本地化存储与合规审计，满足相关法规要求，平衡隐私与全局协同。' },
      { title: '4. 自适应迭代、提升应用灵活度', desc: '云端大模型通过“预训练+微调”，为不同场景定制专属小模型，适配多场景需求；搭建自动更新机制，云端迭代后增量下发至边缘，无需人工干预，提升迭代效率，适配动态风险。' },
    ],
    caseBackground:
      '某大型化工园区（客户）生产区域分散、涉及高危环节，核心需求是全区域安全巡检与异常防控。其原有纯边缘小模型CV系统存在诸多痛点：识别精度不足、异构设备适配难、敏感数据上传有泄露风险、模型迭代效率低，无法满足防控与合规需求，因此采用云边端大小模型协同解决方案升级。',
    caseDifficulties: [
      '1.  实时性与识别精度难以平衡：化工园区需毫秒级识别火灾、气体泄漏等高危隐患，边缘小模型精度不足，依赖云端处理则时延过高，无法满足应急防控需求；',
      '2.  异构边缘设备适配难：园区边缘摄像头、算力盒子硬件规格不一，算力差异大，模型部署兼容性差，需降低适配与运维成本；',
      '3.  敏感数据安全与合规压力大：危化区域影像、人员操作数据敏感，需实现本地化处理，同时满足数据合规审计要求，平衡隐私保护与全局优化；',
      '4.  模型迭代与场景适配难：化工园区隐患类型多样且动态更新，需快速迭代模型，适配不同生产区域（反应区、存储区）的差异化防控需求。',
    ],
    caseSolutions: [
      '1.  大小模型协同调度：边缘部署轻量化小模型，实时识别常规隐患（时延≤50ms），复杂场景上传关键特征至云端大模型复核，识别精度≥96%，满足应急防控需求。',
      '2.  轻量化与异构适配：对边缘小模型量化剪枝优化（≤原体积30%），依托统一算子底座与推理引擎，实现多硬件无缝部署，降低运维成本。',
      '3.  数据安全合规：敏感数据本地处理，仅上传预警结果与关键特征，云端基于非敏感数据优化模型，部署本地化存储，满足合规要求。',
      '4.  多场景适配与迭代：云端大模型“预训练+微调”定制专属模型，搭建自动更新机制，每月1-2次迭代，结合联邦学习提升识别精度。',
    ],
  },
  'vehicle-ai-offense-defense-range': {
    title: '车联网AI攻防靶场解决方案',
    background:
      '车联网通过车载TBox、IVI（信息娱乐系统）、网关和网络架构实现车辆与云端的数据交互，主要功能包括：实时监控车辆状态、远程控制、智能导航与出行服务、车机互联以及V2X车路协同（如紧急车辆避让），从而提升驾驶安全、效率和智能化体验。',
    challenges: [
      { title: '1. 仿真场景贴合度低、测试实战性不足', desc: '传统靶场仿真环境单一，无法精准复现实车、路侧终端、车载业务的真实交互场景，且缺乏攻击场景与流量仿真能力，导致测试结果与实际应用脱节，难以支撑实战化攻防演练与漏洞验证。' },
      { title: '2. 威胁检测能力薄弱、难以应对新型攻击', desc: '车联网攻击手段日趋智能化、隐蔽化，加密流量攻击、AI驱动型攻击频发，传统检测方式难以实现全链路威胁识别，无法精准捕捉隐蔽性漏洞与攻击行为，防御响应滞后。' },
      { title: '3. 资源调度僵化、适配性不足', desc: '攻防测试规模、场景需求动态变化，传统靶场资源分配固定，缺乏弹性扩容与精细化调度能力，无法支撑多场景、高并发的测试任务，资源利用率偏低。' },
      { title: '4. 管控运维复杂、效率低下', desc: '靶场涉及仿真环境、威胁检测、AI模型等多环节，缺乏统一的可视化管控平台，各环节协同不畅，运维流程繁琐，难以实时掌握测试进度、威胁态势与资源使用情况，管控效率低下。' },
    ],
    scenarios: [
      { title: '1. 车载终端安全测试场景', desc: '针对TBOX、车机、车载传感器等终端设备，开展漏洞挖掘、固件安全测试、入侵攻击演练，验证终端设备的抗攻击能力，提前排查安全隐患，保障终端设备安全。' },
      { title: '2. 车载业务安全验证场景', desc: '覆盖OTA升级、车载APP、VSOC等核心车载业务，仿真真实业务场景与攻击场景，验证业务流程的安全性，防范业务篡改、数据泄露等风险，保障业务合规运行。' },
      { title: '3. 攻防演练与人才培养场景', desc: '为车企、安全企业、科研机构提供实战化攻防演练环境，模拟各类攻击场景，提升安全团队的攻防能力，同时为车联网安全人才培养提供标准化、场景化的实训平台。' },
      { title: '4. 安全产品验证与优化场景', desc: '为车联网安全防护产品（如防火墙、入侵检测系统）提供测试验证环境，通过攻防演练验证产品防护效果，助力企业优化产品性能，提升安全防护能力。' },
    ],
    architectureAsset: 'vehicle-ai-range-architecture.png',
    advantages: [
      { title: '1. 底座支撑稳固、资源弹性适配能力突出', desc: '依托车联网环境仿真池化底座，提供弹性计算、虚拟网络等基础资源，可根据攻防测试规模弹性扩容、精细化分配，支撑多场景高并发任务，筑牢靶场运行基础。' },
      { title: '2. 仿真场景全面、攻防测试贴合实战', desc: '搭建虚实结合的高保真仿真环境，覆盖车载核心业务及流量、攻击等多维度仿真，复现真实场景，为攻防演练、漏洞挖掘提供全场景支撑，保障测试实战性。' },
      { title: '3. 威胁检测全面、全链路攻防可控', desc: '依托多维度检测能力，实现流量预处理、日志存储与全链路威胁识别，精准捕捉漏洞与攻击行为，兼顾常规与隐蔽性威胁，助力定位防御薄弱点。' },
      { title: '4. AI深度赋能、攻防智能化水平领先', desc: 'AI技术深度融入攻防全流程，通过模型训练与应用开发，提升威胁识别精度与效率，实现AI资产管控，支撑自动化攻防功能，推动靶场智能化升级。' },
    ],
    caseBackground:
      '某国内主流新能源车企，旗下车型搭载OTA、TBOX等核心业务，需满足欧盟R155、R156法规要求，核心需求是搭建实战型AI攻防靶场，实现终端、业务安全测试、攻防演练及合规检测。其原有实车+简易虚拟靶场测试模式痛点明显：实车测试成本高、无法开展高风险演练，虚拟靶场仿真度低、缺乏AI检测能力，无法应对新型威胁及多团队高并发测试，难以满足规模化与合规需求，因此引入本解决方案。',
    caseDifficulties: [
      '1. 仿真保真度不足：需1:1复现实车电子电气架构、CAN总线及核心业务场景，传统靶场无法实现，难以支撑实战测试。',
      '2. 新型威胁检测难：加密流量、AI驱动型攻击频发，传统检测无法捕捉隐蔽漏洞，手动分析CAN报文效率低。',
      '3. 并发支撑不足：需支撑多团队同步测试，传统靶场资源分配固定、无弹性扩容能力，资源利用率低。',
      '4. 合规与运维协同难：需满足法规可追溯要求，且靶场多环节缺乏统一管控，运维流程繁琐、效率低。',
    ],
    caseSolutions: [
      '1. 搭建高保真仿真环境：依托池化底座，1:1复现实车架构与核心业务场景，支持多维度仿真，替代部分实车测试，降低成本。',
      '2. AI赋能提升效率：部署AI威胁分析层，实现CAN报文自动分析、漏洞智能挖掘，精准检测新型威胁，大幅提升测试效率。',
      '3. 弹性调度支撑并发：依托弹性资源，动态分配算力与场景，支撑多团队高并发测试，资源利用率提升至80%以上。',
      '4. 统一管控协同合规：通过统一平台实现全环节可视化管控，自动生成合规报告，简化运维流程，适配合规与实战需求。',
    ],
  },
}
